import { render, staticRenderFns } from "./UserMessagesInline.vue?vue&type=template&id=41e06251&scoped=true"
import script from "./UserMessagesInline.vue?vue&type=script&lang=js"
export * from "./UserMessagesInline.vue?vue&type=script&lang=js"
import style0 from "./UserMessagesInline.vue?vue&type=style&index=0&id=41e06251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e06251",
  null
  
)

export default component.exports